import React from 'react'
import { Typography, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import { useState } from 'react';

const MobileNav = ({ buttonSx, buttonsText, setMobileOpened }) => {
    const [projects, setProjects] = useState(false);

    const projectsList = [
        {
            name: "Stony Brook Election Visualizer",
            link: "https://sbu-elections.netlify.app",
            external: true,
            icon: "📊"
        },
        {
            name: "Political election statewide simulator",
            link: "https://simulator.nicholasgitman.com",
            external: true,
            icon: "🗳️"
        }
    ];

    return (
        <nav className="max-w-screen p-4">
            <ul className="flex flex-col space-y-2">
                {buttonsText.map(b => (
                    <li key={b.name}>
                        <Link to={b.to}>
                            <Button
                                fullWidth
                                sx={{
                                    ...buttonSx,
                                    color: 'white',
                                    justifyContent: 'flex-start',
                                    py: 1.5,
                                    px: 2,
                                    fontSize: '1rem',
                                    transition: 'all 0.2s ease',
                                    '&:hover': {
                                        bgcolor: 'rgba(255, 255, 255, 0.1)',
                                        transform: 'translateX(8px)'
                                    }
                                }}
                                onClick={() => {
                                    if (b.id) {
                                        window.location.href = b.to;
                                    }
                                    setMobileOpened(false);
                                }}
                            >
                                <Typography
                                    sx={{ fontSize: '1rem', fontWeight: 400 }}
                                    textTransform="none"
                                >
                                    {b.name}
                                </Typography>
                            </Button>
                        </Link>
                    </li>
                ))}
                <li>
                    <Button
                        fullWidth
                        sx={{
                            ...buttonSx,
                            color: 'white',
                            justifyContent: 'space-between',
                            py: 1.5,
                            px: 2,
                            fontSize: '1rem',
                            transition: 'all 0.2s ease',
                            '&:hover': {
                                bgcolor: 'rgba(255, 255, 255, 0.1)',
                            }
                        }}
                        onClick={() => setProjects(!projects)}
                    >
                        <Typography
                            sx={{ fontSize: '1rem', fontWeight: 400 }}
                            textTransform="none"
                        >
                            Projects
                        </Typography>
                        <span className="text-sm">{projects ? '▲' : '▼'}</span>
                    </Button>
                    {projects && (
                        <div className="mt-2 space-y-1 animate-fade-in">
                            {projectsList.map((project, idx) => (
                                <Link
                                    key={idx}
                                    to={project.link}
                                    target={project.external ? "_blank" : undefined}
                                    rel={project.external ? "noopener noreferrer" : undefined}
                                    onClick={() => !project.external && setMobileOpened(false)}
                                >
                                    <div className="flex items-center gap-2 px-4 py-2.5 ml-4 rounded-lg bg-slate-800 hover:bg-slate-700 transition-all duration-200">
                                        <span className="text-lg">{project.icon}</span>
                                        <span className="text-white text-sm font-medium">{project.name}</span>
                                        {project.external && (
                                            <span className="ml-auto text-slate-400 text-xs">↗</span>
                                        )}
                                    </div>
                                </Link>
                            ))}
                        </div>
                    )}
                </li>
            </ul>
        </nav>
    )
}

export default MobileNav